// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.recent_mainSection__DbBMm {
  margin: 4rem 0;

  .recent_cards__8veu3 {
    margin: 1rem 0 4rem;
    display: flex;
    gap: 0.6rem;
    flex-direction: column;
    max-height: fit-content;

    & img {
      max-width: 100%;
      height: auto;
    }

    & h2 {
      margin: 0;
      color: var(--secondary-color);
      font-family: Inter;
      font-size: 1.1rem;
      font-weight: 700;
    }

    & p {
      margin: 0;
      color: var(--secondary-color);
      font-family: Inter;
      font-size: 1rem;
      font-weight: 500;
    }

    & a {
      font-family: Inter;
      font-size: 1rem;
      font-weight: 500;
      color: var(--primary-color);
    }
  }

  & h6 {
    font-family: Inter;
    font-size: 20px;
    font-weight: 700;
  }
}

/* --------media-queries---------- */

@media screen and (max-width: 568px) {
  br {
    display: none;
  }

  .recent_mainSection__DbBMm {
    margin: 1rem 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/RecentNews/recent.module.css"],"names":[],"mappings":"AAAA;EACE,cAAc;;EAEd;IACE,mBAAmB;IACnB,aAAa;IACb,WAAW;IACX,sBAAsB;IACtB,uBAAuB;;IAEvB;MACE,eAAe;MACf,YAAY;IACd;;IAEA;MACE,SAAS;MACT,6BAA6B;MAC7B,kBAAkB;MAClB,iBAAiB;MACjB,gBAAgB;IAClB;;IAEA;MACE,SAAS;MACT,6BAA6B;MAC7B,kBAAkB;MAClB,eAAe;MACf,gBAAgB;IAClB;;IAEA;MACE,kBAAkB;MAClB,eAAe;MACf,gBAAgB;MAChB,2BAA2B;IAC7B;EACF;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA,oCAAoC;;AAEpC;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":[".mainSection {\n  margin: 4rem 0;\n\n  .cards {\n    margin: 1rem 0 4rem;\n    display: flex;\n    gap: 0.6rem;\n    flex-direction: column;\n    max-height: fit-content;\n\n    & img {\n      max-width: 100%;\n      height: auto;\n    }\n\n    & h2 {\n      margin: 0;\n      color: var(--secondary-color);\n      font-family: Inter;\n      font-size: 1.1rem;\n      font-weight: 700;\n    }\n\n    & p {\n      margin: 0;\n      color: var(--secondary-color);\n      font-family: Inter;\n      font-size: 1rem;\n      font-weight: 500;\n    }\n\n    & a {\n      font-family: Inter;\n      font-size: 1rem;\n      font-weight: 500;\n      color: var(--primary-color);\n    }\n  }\n\n  & h6 {\n    font-family: Inter;\n    font-size: 20px;\n    font-weight: 700;\n  }\n}\n\n/* --------media-queries---------- */\n\n@media screen and (max-width: 568px) {\n  br {\n    display: none;\n  }\n\n  .mainSection {\n    margin: 1rem 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainSection": `recent_mainSection__DbBMm`,
	"cards": `recent_cards__8veu3`
};
export default ___CSS_LOADER_EXPORT___;
